<template>
  <v-list-group v-bind:sub-group="subGroup" no-action v-on:click="change(item)" v-bind:ripple="false">
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title>{{item.name}}</v-list-item-title>
      </v-list-item-content>
    </template>
    <template v-for="category in item.subs">
      <v-list-item v-if="!category.item_tree" v-bind:key="category._id" v-on:click="change(category)">
        <v-list-item-content>
          <v-list-item-title>{{category.name}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-categories-list v-else v-bind:item="category" v-bind:key="category._id" sub-group
        v-bind:change="change"/>
    </template>
  </v-list-group>
</template>
<script>
export default {
  name: 'v-categories-list',
  props: {
    item: Object,
    subGroup: Boolean,
    noAction: Boolean,
    change: Function
  }
}
</script>